// @ts-nocheck
import fallbackImage from "@assets/images/fallback-image.svg";
import {useGetRecentGames} from "@hooks/gamesList/useGetRecentGames";
import {useCallback} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {useAuthStore} from "@/store/useAuth.store";
import {Carousel} from "../../../../../../../components/Carousel";
import {HeadingCarousel} from "../../../../../../../components/heading-carousel";

const containerCls = "w-full max-w-full max-[780px]:mx-auto";
const gameCardCls =
  "flex items-center justify-center overflow-hidden rounded-2xl basis-[111px] grow-0 shrink-0 relative cursor-pointer transition-transform duration-200 hover:scale-105 max-[780px]:basis-[95px]";
const gameIconCls = "w-[111px] h-[105px] rounded-2xl object-cover max-md:w-[95px] max-md:h-[97px]";
const playIconCls = "text-xl absolute top-2 right-2";
const loadingIconCls =
  "w-[111px] h-[105px] rounded-2xl bg-[linear-gradient(90deg,var(--color-gray-light-1)_25%,var(--color-gray-light-2)_50%,var(--color-gray-light-1)_75%)] bg-[length:200%_100%] animate-pulse max-md:w-[95px] max-md:h-[97px]";

export const RecentlyPlayedGames = () => {
  const {t} = useTranslation();
  const {recentGames, isPending} = useGetRecentGames();
  const navigate = useNavigate();
  const authStatus = useAuthStore(state => state.authStatus);

  const handleGameClick = useCallback(
    (provider, gameId) => {
      navigate(`/games/${provider}/${gameId}`);
    },
    [navigate]
  );

  if (authStatus !== "authenticated" || (!isPending && recentGames.length === 0)) {
    return null;
  }

  return (
    <div
      id="recentlyPlayedGames"
      className={containerCls}
    >
      <HeadingCarousel
        title={t("recentlyPlayedTitle")}
        subtitle={t("recentlyPlayedSubTitle")}
        icon="▶️"
      />
      <Carousel
        renderItems={() =>
          isPending || recentGames.length === 0
            ? ["skel-1", "skel-2", "skel-3", "skel-4", "skel-5", "skel-6"].map(key => (
                <div
                  key={key}
                  className={gameCardCls}
                >
                  <div className={loadingIconCls} />
                </div>
              ))
            : recentGames.map(game => (
                <div
                  key={game.uniqueId}
                  className={gameCardCls}
                  onClick={() => handleGameClick(game.game_provider, game.game_id)}
                >
                  <img
                    src={game.icon}
                    alt={game.name}
                    onError={e => {
                      e.target.onerror = null;
                      e.target.src = fallbackImage;
                    }}
                    className={gameIconCls}
                  />
                  <span className={playIconCls}>▶️</span>
                </div>
              ))
        }
      />
    </div>
  );
};
